import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { isAPIError } from '@/api/error';

interface PageErrorStateProps {
  error: unknown;
  onRetry?: () => void;
}

export function PageErrorState({ error, onRetry }: PageErrorStateProps): JSX.Element {
  const { t } = useTranslation();
  const key = isAPIError(error) ? error.i18nKey : 'errors.generic';
  const message = t(key, { defaultValue: t('errors.generic') });
  return (
    <EmptyState
      icon="!"
      title={t('errors.generic')}
      body={message}
      action={
        onRetry && (
          <Button onClick={onRetry} block>
            {t('common.retry')}
          </Button>
        )
      }
    />
  );
}
